module.exports = __webpack_public_path__ + "static/aribe-78dfab9b66d992c253440efff289b6f1.jpg";